import styled from '@emotion/styled'

import { Asable } from '../../types/asable'

type SafeHtmlWrapperProps = Asable

export const SafeHtmlWrapper = styled.div<SafeHtmlWrapperProps>``
